import React from 'react';

export function PageHeader({ title, subtitle, children, breadcrumbs }) {
  return (
    <div style={styles.container}>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav style={styles.breadcrumbs}>
          {breadcrumbs.map((crumb, index) => (
            <span key={index}>
              {index > 0 && <span style={styles.separator}>/</span>}
              {crumb.href ? (
                <a href={crumb.href} style={styles.breadcrumbLink}>{crumb.label}</a>
              ) : (
                <span style={styles.breadcrumbCurrent}>{crumb.label}</span>
              )}
            </span>
          ))}
        </nav>
      )}
      <div style={styles.header}>
        <div>
          <h2 style={styles.title}>{title}</h2>
          {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
        </div>
        {children && <div style={styles.actions}>{children}</div>}
      </div>
    </div>
  );
}

const styles = {
  container: {
    marginBottom: '1.5rem'
  },
  breadcrumbs: {
    marginBottom: '0.5rem',
    fontSize: '0.875rem'
  },
  separator: {
    margin: '0 0.5rem',
    color: '#a0aec0'
  },
  breadcrumbLink: {
    color: '#3182ce',
    textDecoration: 'none'
  },
  breadcrumbCurrent: {
    color: '#718096'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  title: {
    margin: 0,
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#1a202c'
  },
  subtitle: {
    margin: '0.25rem 0 0 0',
    color: '#718096',
    fontSize: '0.875rem'
  },
  actions: {
    display: 'flex',
    gap: '0.5rem'
  }
};
